import DepartmentSelect from "@/components/DepartmentSelect.vue";
import SeasonSelect from "@/components/SeasonSelect.vue";
import EmployeeSelect from "@/components/EmployeeSelect.vue";
import { getSeason } from "../utils/utilApi";
import moment from "moment";
import { asItemTable } from "../data/ASItem";
import { post, uploadPost } from "../utils/request";
import { ElMessage } from "element-plus";
import { MAX_UPLOAD_FILE_SIZE, FILE_SPACE_BASE_DIR } from "../utils/utilData";


export default {
  data() {
    return {
      showable: {
        asItemForm: false,
      },
      disable: {
        addTaskBtn: false,
      },
      // 操作人员的部门ID
      departmentId: JSON.parse(sessionStorage.getItem("departmentInfo")).departmentId,
      // 分页控制
      currentPage: 1,
      pagesize: 10,
      asItemTable: [],
      asItemList: [],
      year: moment().format("YYYY"),
      season: getSeason(),
      asForm: {
        userId: "",
        name: "",
        itemDetail: "",
        score: "",
        appendixId: "",
        year: "",
        season: "",
        appendixList: [],
      },
    }
  },
  components: { SeasonSelect, DepartmentSelect, EmployeeSelect },
  name: "ASItem",
  methods: {
    // 切换每页显示数据
    handleSizeChange(val) {
      this.pagesize = val;
      // console.log(`每页 ${val} 条`);
    },
    // 切换页面
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(`当前页: ${val}`);
    },
    formatter(row, column) {
      if (column.property == 'appendix') {
        if (row.appendixList != null) {
          return row.appendixList[0].name;
        }
      } else {
        return row[column.property];
      }
    },
    // 查看按钮
    handleEdit(index, row) {
      this.asForm = this.$options.data().asForm;
      this.asForm = row;
      this.asForm.year = this.year;
      this.asForm.season = this.season;
      // 查看时不能点击确认添加
      this.disable.addTaskBtn = true;
      this.showable.asItemForm = true;

    },
    handleAddItem() {
      this.asForm = this.$options.data().asForm;
      this.disable.addTaskBtn = false;
      this.showable.asItemForm = true;
    },
    doCancel() {
      this.showable.asItemForm = false;
    },
    /**
     * @description 添加加减分具体事项记录
     * 
     * @function POST /asItemScore/add
     * @param userId int 用户ID
     * @param itemDetail string 加减分事由
     * @param score int 具体分数
     * @param year int 年度
     * @param season string 季度
     * @param appendixId int 附件ID
     * 
     * @returns R.success().code(200).message("成功");
     * 
     */
    addAsRecord() {
      // this.$refs.upload.submit();
      post('/asItemScore/add', JSON.stringify(this.asForm)).then((res) => {
        if (res.code == 200) {
          this.searchAsRecord();
        }
      });
      this.showable.asItemForm = false;
    },
    /**
     * @description 删除加减分事项记录
     * @function POST /asItemScore/delete
     * 
     * @param id int 事项ID
     * 
     * @returns R.success().code(200).message("成功");
     */
    handleDelete(index, row) {
      post('/asItemScore/delete', JSON.stringify({ id: row.id })).then((res) => {
        if (res.code == 200) {
          this.asItemList.splice(index, 1);
        }
      });
    },
    /**
     * @description 查询加减分的事项记录
     * @function POST /asItemScore/search
     * 
     * @param year int 年度
     * @param season string 季度
     * @param departmentId int 局级管理账号所在的部门ID
     * 
     * @returns asItemList[]
     * @returns 集合中每一项的属性为 id序号, name人员姓名, departmentName科室名称, itemDetail加减分事由, score分数, appendix证明材料url
     */
    searchAsRecord() {
      let data = {
        year: this.year,
        season: this.season,
        departmentId: this.departmentId
      }
      post('/asItemScore/search', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.asItemList = JSON.parse(res.data.asItemList);
          // 附件修改
        }
      });
    },
    uploadFile(param) {
      let form = new FormData();
      form.append('file', param.file);
      form.append('userId', JSON.parse(sessionStorage.getItem("userInfo")).userId);
      uploadPost('/appendix/upload', form).then(res => {
        // 上传成功后返回的ID
        this.asForm.appendixList = [];
        // 上传成功后把文件信息push进附件数组中
        this.asForm.appendixList.push(JSON.parse(res.data.appendix));
        this.asForm.appendixId = JSON.parse(res.data.appendix).appendixId;
        this.$refs.uploadAppendix.clearFiles();

      })
    },
    // 获取文件
    getUploadFile(file, fileList) {
      let allowedExtention = ["pdf", "doc", "docx", "jpg", "jpeg", "png", "rar", "zip"];
      let fileExtention = file.name.substring(file.name.lastIndexOf(".") + 1);
      // 限制文件上传类型
      if (allowedExtention.indexOf(fileExtention) === -1) {
        ElMessage.error("该文件类型不允许上传", {
          duration: 3 * 1000,
        });
        this.asForm.appendixList = [];
        return;
      }
      // 每次上传文件前都先将其清空
      this.asForm.appendixList = [];
      // 文件上传不能大于10M
      if (file.size / 1024 / 1024 > MAX_UPLOAD_FILE_SIZE) {
        ElMessage.error("文件大小超过" + MAX_UPLOAD_FILE_SIZE + "M, 不予上传", {
          duration: 3 * 1000,
        });
        this.asForm.appendixList = [];
        return;
      }
      // 每次上传就自动调用上传函数
      this.$refs.uploadAppendix.submit();
    },
    // 下载文件
    handlePreview(file) {
      var a = document.createElement("a");
      var event = new MouseEvent('click');
      a.download = file.name;
      a.href = FILE_SPACE_BASE_DIR + file.url;
      a.dispatchEvent(event);
    },
    // 删除附件
    handleRemove(file) {
      let data = {
        appendixId: file.appendixId,
        type: 2,
      }
      post('/appendix/delete', JSON.stringify(data)).then((res) => {
        if (res.code == 200) {
          this.behaviorForm.appendixList = [];
        }
      });
    }
  },
  created() {
    this.asItemTable = asItemTable;
    this.searchAsRecord();
  },
  watch: {
    year() {
      this.searchAsRecord();
    },
    season() {
      this.searchAsRecord();
    }
  }
}